<template>
    <v-container>
        <v-row class="pa-2">
            <v-text-field outlined dense hide-details
                          label="User Email"></v-text-field>
        </v-row>
        <v-row class="pa-2">
            <v-select outlined dense hide-details
                      label="Type"
                      v-model="selectedLogType"
                      :items="logTypes"></v-select>
        </v-row>
        <v-row class="pa-2">
            <v-date-picker range no-title class="elevation-0"
                           color="primary"
                           v-model="filters.dateRange">
                <template>
                    <v-checkbox dense hide-details
                                color="primary"
                                v-if="filters.dateRange.length === 1" class="mt-n5"
                                v-model="showAllSince"
                                label="Show all since"></v-checkbox>
                </template>
            </v-date-picker>
        </v-row>
        <v-row class="pa-2">
            <v-btn block depressed
                   @click="doSearch"
                   color="primary">Refresh
            </v-btn>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: "ReportsFilters",

    computed: {
      singleDateSelected() {
        return this.filters.dateRange.length === 1 && !this.showAllSince;
      },
      selectedLogType: {
        get() {
          return this.$store.getters['reports/SEARCH_TYPE']
        },
        set(v) {
          this.$store.commit('reports/SET_SEARCH_TYPE', v)
        }
      }
    },

    data() {
      return {
        filters: {
          userEmail: '',
          dateRange: []
        },
        logTypes: [
          {text: 'Session', value: 'sessions'},
          {text: 'Edit/Deletes', value: 'tools'},
        ],
        showAllSince: false
      }
    },

    watch: {
      selectedLogType(after, before) {
        this.doSearch();
      }
    },

    methods: {
      doSearch() {
        if (this.selectedLogType === 'sessions') {
          this.$store.dispatch('reports/FETCH_SESSION_LOGS', {singleDate: this.singleDateSelected , ...this.filters})
        }
        if (this.selectedLogType === 'tools') {
          this.$store.dispatch('reports/FETCH_TOOL_LOGS', {singleDate: this.singleDateSelected , ...this.filters})
        }
      },
    },

    mounted() {
      this.doSearch();
    }
  }
</script>

<style scoped>
    .picker__body {
        background: none;
    }
</style>
